<template>
  <!-- <div id="player-con"></div> -->
  <video :src="VodUrl" :poster="poster" controls="controls" controlslist="nodownload" style="float:left;width:100%;height:100%;"></video>
</template>

<script>
import { getToken } from '@/utils/auth';

export default {
  components: {},
  data() {
    return {
      VodUrl: '',
      poster:''
    };
  },
  watch: {

  },

  mounted() {
    document.oncontextmenu = new Function("event.returnValue=false;");
    document.onselectstart = new Function("event.returnValue=false;");
    this.sApi('getVodUrl', { code: this.$route.params.ID, token: getToken() }).then(res => {
      if (res.code == 100) return;
      this.VodUrl = res.source;
      this.poster = this.ossUrl + res.cover
      // new Aliplayer({
      //   id: "player-con",
      //   source: res.source,
      //   cover: this.ossUrl + res.cover,
      //   width: "100%",
      //   height: "100%",
      //   autoplay: true,
      //   preload: false,
      //   isLive: false
      // });
    });
    setInterval(function () {
      var obj = document.getElementsByClassName('xl-chrome-ext-bar');
      if (obj.length > 0) {
        obj[0].remove();
        console.log("hahaha");
      }
    }, 500);
  },
  created() { },
  methods: {

  },
};
</script>

<style lang="scss" >
html,
body,
.wssa {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.navbar {
  display: none;
}
</style>